<span class="flex justify-center items-center h-full">
  @if (!isIconMenu && iconName && iconColor) {
    <span [ngClass]="getIconClass(iconName)" [style.color]="iconColor" [style.size]="iconSize">
      <span class="path1"></span>
      <span class="path2"></span>
    </span>
  }
  @if (!iconName) {
    Not Available
  }

  @if (isIconMenu) {
    <a class="cell-icon" [matMenuTriggerFor]="menu">
      <span
        class="center-icon r1-icon"
        [class]="getIconClass(iconName)"
        [style.color]="iconColor"
        [style.size]="iconSize"
      >
      </span>
    </a>
    <mat-menu #menu="matMenu">
      @for (item of menuItems; track item.label) {
        <button mat-menu-item (click)="item.command?.()">
          <span>{{ item.label }}</span>
        </button>
      }
    </mat-menu>
  }
</span>
